<template>
  <router-link
    v-if="loaded"
    v-show="getNewCertifierCredentialRequired && $route.path !== '/doctor/user/certificate'"
    :to="'/doctor/user/certificate'"
    tag="div"
    class="certifier-alert"
  >
    <div class="certifier-alert__wrapper">
      <p>
        <strong>Atenção:</strong>

        <span class="certifier-alert__label">
          O seu token expirou. Clique aqui para renová-lo e continuar assinando
          seus documentos digitalmente.
        </span>
      </p>
    </div>
  </router-link>
</template>

<script>

export default {
  data () {
    return {
      loaded: false
    }
  },
  computed: {
    getNewCertifierCredentialRequired () {
      return this.$store.getters.getNewCertifierCredentialRequired
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.$http.get(
        `/${this.fn_GET_PARENT_ROUTE(this.$route)}/soluti_cess/credential?order[u.createdAt]=DESC&itensPerPage=1`,
        this.$store.getters.getAuthHeader
      ).then(({ data }) => {
        if (data.data && data.data.length) {
          // take the last credential
          const credentialExpiration = data.data[data.data.length - 1].credentialExpiresAt

          const expirationDate = this.$moment(credentialExpiration)
          const nowDate = this.$moment(new Date())

          const diff = nowDate.diff(expirationDate, 'hours')

          if (diff <= -2) {
            this.$store.dispatch('setNewCertifierCredentialRequired', false)
            return
          }
        }
        this.$store.dispatch('setNewCertifierCredentialRequired', true)
      }
      ).catch((err) => {
        // In this case, Doctor doesnt have an integration (or it`s an error)
        console.warn(err)
        this.$store.dispatch('setNewCertifierCredentialRequired', false)
      }).finally(() => {
        this.fn_HIDE_PROGRESS()
        this.loaded = true
      })
    }
  }
}
</script>
